import { NgModule } from "@angular/core";
import { ExpandablePanelComponent } from "@/shared/components/accordion/expandable-panel.component";
import { SectionModule } from "@/shared/components/section/section.module";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatIconModule } from "@angular/material/icon";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [ExpandablePanelComponent],
  imports: [
    SectionModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatIconModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  exports: [ExpandablePanelComponent],
  providers: [],
})

export class ExpandablePanelModule { }
